import { Widget } from '@typeform/embed-react';

type TypeformProps = {
  initialData?: Record<string, string | number | boolean | undefined>;
  typeformId: string;
  onSubmit?: () => void;
};

const Typeform = ({ initialData, onSubmit, typeformId }: TypeformProps) => {
  return (
    <Widget
      hidden={{
        ...initialData,
        source: 'web-app',
      }}
      hideHeaders
      id={typeformId}
      onSubmit={onSubmit}
      opacity={1}
      style={{ height: '100%', width: '100%' }}
    />
  );
};

export default Typeform;
